// Admin MultiLanguageInput `Translates[]` yapısı ile backend `DataJson`
// ({title:{en,tr,...}, body:{en,...}}) arasında köprü. Dil kodu öneki (en/tr/de…)
// LanguageId (EnumId) üzerinden `languages` listesindeki Code'dan çözülür.

export const LEGAL_SLUGS = [
  { EnumId: "privacy", Name: "Gizlilik Politikası (privacy)" },
  { EnumId: "terms", Name: "Kullanım Şartları (terms)" },
  { EnumId: "cookies", Name: "Çerez Politikası (cookies)" },
  { EnumId: "user-agreement", Name: "Kullanıcı Sözleşmesi (user-agreement)" },
  { EnumId: "distance-sales", Name: "Mesafeli Satış Sözleşmesi (distance-sales)" },
];

type Lang = { EnumId: string; Code: string };

const prefix = (code: string) => (code || "").split("-")[0];

// Formik değerleri (Translates + düz alanlar) → backend body.
export function toBody(values: any, languages: Lang[]) {
  const title: Record<string, string> = {};
  const body: Record<string, string> = {};
  (values.Translates || []).forEach((tr: any) => {
    const lang = languages.find((l) => l.EnumId === tr.LanguageId);
    if (!lang) return;
    const p = prefix(lang.Code);
    title[p] = tr.Title || "";
    body[p] = tr.Body || "";
  });
  return {
    Slug: values.Slug,
    Order: Number(values.Order) || 0,
    IsActive: values.IsActive === true || values.IsActive === "true",
    EffectiveDate: values.EffectiveDate || null,
    DataJson: JSON.stringify({ title, body }),
  };
}

// Backend satırının DataJson'ı → Formik Translates (dil başına).
export function toTranslates(dataJson: string, languages: Lang[]) {
  let parsed: any = {};
  try {
    parsed = JSON.parse(dataJson || "{}");
  } catch {
    parsed = {};
  }
  const title = parsed.title || {};
  const body = parsed.body || {};
  return languages.map((l) => {
    const p = prefix(l.Code);
    return { LanguageId: l.EnumId, Title: title[p] || "", Body: body[p] || "" };
  });
}
